module.exports = __webpack_public_path__ + "img/adb.09884c1f.svg";